import * as React from 'react';
import { Box } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { Product, getProducts } from '../../../types/Product';
import { EditableTable } from '../../../subs/EditableTable';

import { AlertProps } from '@mui/material/Alert';
import { useSnackbar } from '../../../../contexts/SnackBarContext';

export const ProductsAdminView = () => {
    const { showSnackbar } = useSnackbar();
    const [allData, setallData] = React.useState<Product[]>([]);

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    React.useEffect(() => {
        const fetchAllProducts = async () => {
            const allProductsResponse = await getProducts(new AbortController());
            if (allProductsResponse.failed) {
                showUserFeedback(allProductsResponse.errorText);
                return;
            }
            setallData(allProductsResponse.result);
        }
        fetchAllProducts();
    }, [showUserFeedback]);

    const columns: GridColDef[] = [
        {
            field: 'guid',
            headerName: 'Guid',
            flex: 1
        },
        {
            field: 'name',
            headerName: 'Name',
            flex: 1
        },
        {
            field: 'companyId',
            headerName: 'Company ID',
            flex: 1
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1
        },
        {
            field: 'id'
        }
    ];

    return <React.Fragment >
        <Box sx={{ flexGrow: 1, width: "100%" }} style={{ overflow: 'auto' }}>
            <EditableTable
                columns={columns}
                rows={allData}
                setAllRows={setallData}
            />
        </Box>
    </React.Fragment >
}